var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.getWrapperComponent,_vm._b({tag:"component",attrs:{"data-component":"app-logo","data-size":_vm.size}},'component',_vm.getWrapperProps,false),[_c('img',{key:_vm.getSrc,attrs:{"src":_vm.getSrc,"alt":"Bridge128"}})])}
var staticRenderFns = []

export { render, staticRenderFns }